import { getNextPageParam } from "PFCore/helpers/get_next_page_param";
import {
  fetchKPIEvents,
  FetchKPIEventsParams,
  FetchKPIEventsResponse
} from "PFCore/services/kpi/fetch_kpi_events";
import { Id, InfiniteQueryOptions } from "PFCore/types";

import { useInfiniteQuery } from "../use_infinite_query";
import { KPIKeys } from "./query_keys";

export const useKPIEventsInfinite = (
  engagementId: Id,
  params: Omit<FetchKPIEventsParams, "page">,
  options: InfiniteQueryOptions<FetchKPIEventsResponse> = {}
) =>
  useInfiniteQuery({
    queryKey: KPIKeys.kpiEvents(engagementId, params),
    queryFn: ({ pageParam }) => fetchKPIEvents(engagementId, { ...params, page: pageParam }),
    getNextPageParam,
    initialPageParam: 1,
    retry: false,
    ...options
  });
